module.exports = __webpack_public_path__ + "img/cargo-wagon-door-horizontal-end.983b4330.png";